<script lang="ts">
  let { color = 'currentColor' } = $props()
</script>

<svg
  width="17"
  height="17"
  viewBox="0 0 17 17"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M0.750122 3.31033L8.01273 0.830412C8.34982 0.715308 8.71687 0.723919 9.0482 0.854704L15.7501 3.5002L14.1528 10.2445C14.0803 10.5507 13.9133 10.8263 13.6756 11.0323L8.34506 15.6521L2.84374 11.0381C2.59404 10.8287 2.41935 10.5436 2.34607 10.2261L0.750122 3.31033ZM8.34506 15.6521V7.29767M15.7501 3.5002L8.34506 7.29767M0.750122 3.31033L8.34506 7.29767"
    stroke={color}
    stroke-width="1.5"
    stroke-linejoin="round"
  />
</svg>
